<template>
  <div ref="plate" class="plate" v-show="$bus.shareInfo.show">
    <div class="plate-close dialog-close" @click="hidePlate"></div>
    <div class="plate-shoot" @click.stop="shootImg">
      <i class="plate-camera"></i>
      <span class="plate-text bebas-font">{{$bus.transify['LUCKY_SCREENSHOOT']}}</span>
    </div>
    <div class="plate-body" @click="endPlate">
      <div class="plate-body-title bebas-font">{{$bus.transify['LUCKY_BUY_GREETINGS']}}</div>
      <Item class="item" type="feature-reward" :shine="true" :nums="$bus.activePrize.item_num" :imgSrc="$bus.activePrize.item_img">
        <ff-mark class="item-mask"
          type="light"
          points="12, 2.5 2.5, 12 2.5, 26 26, 2.5">
          <div class="mark-text diamond-type">
            <i class="diamond"></i>
            <span class="text bebas-font">{{ $bus.currentShareDiscount.discount }}</span>
          </div>
        </ff-mark>
      </Item>
      <div class="plate-body-name bebas-font">{{ $bus.activePrize.item_name }}</div>
      <div class="plate-body-diamond">
        <i class="diamond"></i>
        <span class="now-price bebas-font">{{ $bus.currentShareDiscount.discount }}</span>
        <span class="origin-price bebas-font">{{$bus.activePrize.price}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Item from '@/components/common/Item.vue'
import ffMark from '@/components/common/Mark.vue'

import VueAnime from '@/utils/animate.js'
const anime = new VueAnime()
export default {
  components: {
    Item,
    ffMark
  },
  data () {
    return {
      shoot: false
    }
  },
  watch: {
    '$bus.shareInfo.show': {
      deep: true,
      handler (val) {
        if (val) {
          this.showPlate()
        }
      }
    }
  },
  methods: {
    showPlate () {
      const timeline = anime.timeline()
      timeline.add({
        targets: '.plate',
        opacity: [0, 1],
        duration: 800,
        easing: 'easeOutBack'
      }).add({
        targets: '.plate-body',
        scale: [0.8, 1],
        easing: 'easeOutBack'
      }, 0).add({
        targets: '.plate-close',
        translateY: ['-100%', 0],
        opacity: [0, 1],
        easing: 'easeOutBack'
      }, 0).add({
        targets: '.plate-shoot',
        translateY: ['200%', 0],
        opacity: [0, 1],
        easing: 'easeOutBack'
      }, 0)
    },
    hidePlate () {
      const timelineOut = anime.timeline(() => {
        anime.maskOut(this.$refs.plate, () => {
          this.$bus.activePrize = {}
          this.$bus.shareInfo.show = false
          this.$refs.plate.style.opacity = 1
        })
      })
      timelineOut.add({
          targets: '.plate-close',
          translateY: [0, '-100%'],
          opacity: [1, 0],
          easing: 'easeInBack'
        }).add({
          targets: '.plate-shoot',
          translateY: [0, '200%'],
          opacity: [1, 0],
          easing: 'easeInBack'
        }, 0)
    },
    shootImg () {
      this.$bus.clickSound = true
      const timelineOut = anime.timeline()
      timelineOut.add({
        targets: '.plate-close',
        translateY: [0, '-100%'],
        opacity: [1, 0],
        easing: 'easeInBack'
      }).add({
        targets: '.plate-shoot',
        translateY: [0, '200%'],
        opacity: [1, 0],
        easing: 'easeInBack'
      }, 0)
      this.shoot = true
      this.$bus.addGA('screenShot', 'sucess')
    },
    endPlate () {
      if (this.shoot) {
        const timeline = anime.timeline()
        timeline.add({
          targets: '.plate-close',
          translateY: ['-100%', 0],
          opacity: [0, 1],
          easing: 'easeOutBack'
        }).add({
          targets: '.plate-shoot',
          translateY: ['200%', 0],
          opacity: [0, 1],
          easing: 'easeOutBack'
        }, 0)
        this.shoot = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.plate {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  .plate-close {
    position: absolute;
    z-index: 2;
    @include px2res(left, 34);
    @include px2res(top, 30);
    @include px2res(width, 62);
    @include px2res(height, 62);
  }
  .plate-shoot {
    position: absolute;
    z-index: 2;
    @include px2res(right, 63);
    @include px2res(bottom, 56);
    @include px2res(min-width, 225);
    @include px2res(height, 56);
    @include px2res(padding, 0, 10);
    background-size: 100% 100%;
    @include flexrc;
    color: #f1bb4f;
    .plate-camera {
      @include px2res(width, 33);
      @include px2res(height, 28);
      @include px2res(margin-right, 17);
    }
    .plate-text {
      @include px2res(font-size, 35);
      @include px2res(margin-top, 5);
    }
  }
  .plate-body {
    width: 100%;
    height: 100%;
    @include flexcc;
    .item {
      @include px2res(width, 200);
      @include px2res(height, 200);
      @include px2res(margin, 10, auto, 20);
    }
  }
  .mark {
    @include px2res(font-size, 28)
  }
  .mark-text {
    transform: scale(1) rotate(-45deg);
    top: 22%;
    left: 8%;
    .diamond {
      @include px2res(width, 24);
      @include px2res(height, 24);
      @include px2res(margin-right, 2);
    }
  }
}
.plate-body-title {
  color: #FBED65;
  @include px2res(font-size, 60);
  @include text-gradient(rgba(255,255,255,1) 35%, rgba(251,237,101,1) 65%);
}
.plate-body-name {
  @include px2res(font-size, 24);
  @include px2res(min-width, 200);
  @include px2res(max-width, 512);
  @include px2res(min-height, 48);
  @include px2res(padding, 6, 40);
  @include flexrc;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, .7) 40%,
    rgba(0, 0, 0, .7) 60%,
    rgba(0, 0, 0, 0) 100%
  );
}
.plate-body-diamond {
  @include flexrc;
  align-items: flex-end;
  line-height: 1;
  @include px2res(margin-top, 20);
  .diamond {
    @include px2res(width, 66);
    @include px2res(height, 56);
  }
  .now-price {
    @include px2res(font-size, 70);
    @include px2res(line-height, 60);
    @include text-gradient(rgba(0, 255, 251, 1) 20%, rgba(0, 192, 255, 1) 80%);
    filter: drop-shadow(0 1px 10px rgba(0, 6, 242, .8));
  }
  .origin-price {
    position: relative;
    color: #63748A;
    @include px2res(font-size, 35);
    @include px2res(margin-left, 10);
  }
  .origin-price::after {
    content: '';
    position: absolute;
    width: 110%;
    height: 2px;
    left: -2%;
    top: 50%;
    margin-top: -2px;
    background-color: #63748A;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/index.vue